import React from "react";
import ModalUi from "../primitives/ModalUi";
import { modalSubmitBtnColor } from "../constant/const";

const typeConfig = {
  success: { title: "Success", headColor: "#3aa963" }, // green
  warning: { title: "Warning", headColor: "#e2b222" }, // yellow
  error: { title: "Error", headColor: "#c34141" } // red
};

const CommonMessageModal = ({
  isOpen,
  type = "success", // success | warning | error
  title,
  message,
  onClose,
  onConfirm,
  showButton = true
}) => {
  if (!isOpen) return null;

  const config = typeConfig[type] || typeConfig.success;

  return (
    <ModalUi
      isOpen={isOpen}
      title={title || config.title}
      handleClose={onClose}
      showHeader={true}
      showClose={true}
      headColor={config.headColor}
      styleClass="fixed top-5 left-1/2 transform -translate-x-1/2 w-[90%] md:w-[500px] text-sm bg-white rounded shadow-md overflow-y-auto hide-scrollbar"
    >
      <div className="m-[20px]">
        <div className="text-base font-normal text-black">
          {message || "Action completed successfully"}
        </div>

        {showButton && (
          <>
            <hr className="bg-[#ccc] mt-4" />
            <div className="flex justify-end mt-3 gap-2">
              {onConfirm ? (
                <>
                  <button
                    onClick={onConfirm}
                    className="px-4 py-1.5 text-white rounded shadow-md focus:outline-none"
                    style={{ backgroundColor: modalSubmitBtnColor }}
                  >
                    Yes
                  </button>
                  <button
                    onClick={onClose}
                    className="px-4 py-1.5 text-black border-[1px] border-[#ccc] shadow-md rounded focus:outline-none"
                  >
                    No
                  </button>
                </>
              ) : (
                <button
                  onClick={onClose}
                  className="px-4 py-1.5 text-white rounded shadow-md focus:outline-none"
                  style={{ backgroundColor: modalSubmitBtnColor }}
                >
                  OK
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </ModalUi>
  );
};

export default CommonMessageModal;
